import {Utilities} from '@shared/utilities/utilities.model';

export class EsbContractModel {

    vehicleType: string;
    contractNumber: string;
    plate: string;
    chassis: string;
    model: string;
    brand: string;
    modelDate: string;
    contractEndDate: string;
    vehicleSeats: number;
    kw: string;
    driverFirstName: string;
    driverLastName: string;
    customerId: string;
    customerTradingName: string;
    driverId: string;
    isCustomerBlackList: boolean;
    fuelType: string;
    transmission: string;
    replacementVehicle: string;
    replacementVehicleDuration: string;

    constructor(model: any) {
        if (!Utilities.isVoid(model)) {
            this.vehicleType = model.vehicle_type;
            this.contractNumber = model.contract_number;
            this.plate = model.plate;
            this.chassis = model.chassis;
            this.fuelType = model.fuel_type;
            this.model = model.model;
            this.brand = model.brand;
            this.modelDate = model.model_date;
            this.contractEndDate = model.contract_end_date;
            this.vehicleSeats = model.vehicle_seats;
            this.kw = model.kw;
            this.customerTradingName = model.customer_trading_name;
            this.driverFirstName = model.driver_first_name;
            this.driverLastName = model.driver_last_name;
            this.customerId = model.customer_id;
            this.driverId = model.driver_id;
            this.isCustomerBlackList = model.is_customer_black_list;
            this.transmission = model.transmission;
            this.replacementVehicle = model.replacement_vehicle;
            this.replacementVehicleDuration = model.replacement_vehicle_duration;
        }
    }
}

